import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Cells extends PureComponent {
  render() {
    const { children, className, form, checkbox, radio, ...others } = this.props;
    const cls = classNames({
      "weui-cells": true,
      "weui-cells_form": form,
      "weui-cells_checkbox": checkbox,
      "weui-cells_radio": radio
    }, className);

    return <div className={ cls } { ...others }>{ children }</div>;
  }
}
